













































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Tab, Tabs, List, Icon, Toast, Overlay, Checkbox, Field } from "vant";
import AppPrompt from "@/components/AppPrompt.vue";
import Header from "@/components/Header.vue";
import VideoBox from "@/components/VideoBox.vue";
import Gift from "@/components/Gift.vue";
import Footer from "@/components/Footer.vue";
import ChatRoomItem from "@/components/ChatRoomItem.vue";
import LiveRoomItem from "@/components/LiveRoomItem.vue";
import Suspension from "@/components/Suspension.vue";
import GiftTips from "@/components/GiftTips.vue";
import request from "@/api/index";
import native from "@/common/Native";
import {
  IChatRoomItem,
  IDetail,
  IGiftItem,
  IGiftTipsItem,
  ILiveRoomItem,
  IShareInfo,
  ICount,
  ILiveShare
} from "@/api/types";
import { needToken, toastWithDelay } from "@/common/decorator";
import { isOpenInWechat } from "@/common/utils";
import store from "@/store";
import {
  recordCount,
  recordTime,
  recordVideo,
  removRecordTime,
  removRecordVideo
} from "@/api/dataCollect";

interface ITabItem {
  title: string;
  icon: string;
  activeIcon: string;
  loading: boolean;
  finished: boolean;
  onLoad: Function;
}
@Component({
  components: {
    AppPrompt,
    Header,
    VideoBox,
    ChatRoomItem,
    LiveRoomItem,
    Gift,
    Footer,
    Suspension,
    GiftTips,
    Icon,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    vanOverlay: Overlay,
    vanCheckbox: Checkbox,
    vanField: Field
  }
})
export default class Home extends Vue {
  /** 直播详情 */
  detail: IDetail | null = null;
  /** 礼物显示 */
  showGift = false;
  /** 顶部打开app */
  shareInfo: IShareInfo | null = null;
  /** 礼物列表 */
  giftList: IGiftItem[] = [];
  /** 聊天室列表 */
  chatRoomList: IChatRoomItem[] = [];
  /** 直播列表 */
  liveRoomList: ILiveRoomItem[] = [];
  /** 弹幕列表 */
  barrageList: IChatRoomItem[] = [];
  /** 展示礼物 */
  giftTips: IGiftTipsItem[] = [];
  /** 弹幕开关 */
  showBarrage = true;
  /** 弹幕title */
  showBarrageName = false;
  /** 是否开起高性能模式 */
  isHighPerformance = false;
  /** 是否开启政务云接口 */
  zwyIfcOn = true;
  /** 高性能下浏览量和点赞量 */
  countJson: ICount | null = null;
  // 是否静音
  liveMute: number | null = null;
  // 聊天室排序
  chatRoomSort = [
    {
      name: "按发布时间",
      value: "1"
    },
    {
      name: "按点赞量",
      value: ""
    }
  ];
  chatRoomSortindex = 1;
  showChatRoomSort = false;

  zanStatus = false;
  showcomment = false;
  checked = false;
  message = "";
  commentSavedata = {
    sourceType: "",
    sourceId: "",
    passiveReplyName: "",
    passiveReplyId: ""
  };

  tabList: ITabItem[] = [
    {
      title: "直播间",
      icon: "",
      activeIcon: "",
      loading: false,
      finished: false,
      onLoad: () => {
        this.getLiveRoom("load");
      }
    },
    {
      title: "聊天室",
      icon: "",
      activeIcon: "",
      loading: false,
      finished: false,
      onLoad: () => {
        this.getChatRoomList();
      }
    }
  ];
  isOpenApp = false;
  isstaticJson = false;
  active = 0;
  liveRoomSort = "";

  /** 轮询 直播间和聊天室数据 */
  taskTimer = 0;
  /** 轮询 浏览量和点赞量 */
  taskCountTimer = 0;
  /** 轮询 全局配置 */
  taskConfigTimer = 0;

  // 主持人筛选id
  hostIds: string[] = [];
  get isShowHeader() {
    if (!native.isOpenInApp() || native.getOS() === "iOS") {
      return false;
    }
    return true;
  }

  get liveRoomSortIcon() {
    if (this.liveRoomSort === "DESC") {
      return require("../assets/image/降序@2x.png");
    } else {
      return require("../assets/image/升序@2x.png");
    }
  }

  get liveRoomSorttext() {
    if (this.liveRoomSort === "DESC") {
      return "按时间降序";
    } else {
      return "按时间升序";
    }
  }
  loading = false;
  finished = false;
  list: any = [];
  get activeItem() {
    return this.tabList[this.active];
  }

  get appId() {
    return this.$store.state.appId;
  }

  get infoClassifyId() {
    return this.$store.state.infoClassifyId;
  }
  @Watch("$store.state.token", { immediate: true, deep: true })
  onChangeValue(newVal: string, oldVal: string) {
    if (this.$store.state.detail && newVal) {
      if (this.$store.state.detail.weChatId && isOpenInWechat()) {
        this.getDetail();
        /** 聊天室列表 */
        this.chatRoomList = [];
        /** 直播列表 */
        this.liveRoomList = [];
        this.getLiveRoom();
        this.getChatRoomList();
        // this.getConfigJson();
      }
    }
  }
  beforeDestroy() {
    removRecordTime();
    removRecordVideo();
  }
  async mounted() {
    const staticJson: any = await request.getStaticJson();
    const id = parseInt(this.$route.query.id as string);
    if (staticJson.indexOf(id) != -1) {
      this.isstaticJson = true;
    }
    this.isOpenApp = !native.isOpenInApp();
    if (native.isOpenInApp()) {
      native.setBottomBar();
    }
    this.getConfigJson();
    this.getCountJson();
    this.taskCountList();
    // setTimeout(() => {
    //   store.commit("SET_STATE", {
    //     sessionId: "967971d714e64a25a0f1cab9a093089a",
    //     token: "967971d714e64a25a0f1cab9a093089a",
    //   });
    // }, 200);
    // 滚动
    window.addEventListener(
      "scroll",
      () => {
        //scrollTop是滚动条滚动时，距离顶部的距离
        //为了保证兼容性，这里取两个值，哪个有值取哪一个
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        //windowHeight是可视区的高度
        const windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        //scrollHeight是滚动条的总高度
        const scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        //滚动条到底部的条件
        if (scrollTop + windowHeight >= scrollHeight - 10) {
          const item = this.tabList[this.active];
          if (!item.loading && !item.finished) {
            item.loading = true;
            item.onLoad();
          }
        }
      },
      true
    );
  }

  async getAppConfig() {
    const result = await request.getAppConfig();
    if (result) {
      for (let i = 0; i < result.length; i++) {
        if (result[i].appId == this.appId) {
          this.liveMute = result[i].appConfig.liveMute ?? 1;
          this.$store.commit("SET_STATE", {
            hideDetailViewCount: result[i].appConfig.hideDetailViewCount
          });
          break;
        }
      }
    }
  }

  /** @description 请不要修改这里的逻辑，这里要配合页面跳转后进行筛选功能 */
  async activated() {
    this.$route.query.id &&
      this.$store.commit("SET_STATE", {
        infoClassifyId: this.$route.query.id
      });
    if (this.$store.state.checkedHosts.length) {
      this.hostIds = this.$store.state.checkedHosts;
    } else {
      this.hostIds = [];
    }
    // this.liveRoomList = [];

    if (this.$store.state.detail) {
      this.detail = this.$store.state.detail;
    }

    /** 重置tabList数据 */
    this.tabList = [
      {
        title: "直播间",
        icon: "",
        activeIcon: "",
        loading: false,
        finished: false,
        onLoad: () => {
          this.getLiveRoom("load");
        }
      },
      {
        title: "聊天室",
        icon: "",
        activeIcon: "",
        loading: false,
        finished: false,
        onLoad: () => {
          this.getChatRoomList();
        }
      }
    ];

    if (this.firstEntry) {
      this.getLiveRoom("load");
      this.initTab();
    }
    this.taskConfigList();

    // await this.getConfigJson();

    if (!native.isOpenInApp() && this.zwyIfcOn) {
      await this.addViewCount();
    }
  }

  /** tab 初始化 */
  initTab() {
    if (
      this.$route.query.id == "97747021" ||
      this.$route.query.id == "97748176" ||
      this.$route.query.id == "97967129"
    ) {
      this.tabList[0].title = "滚动播报";
    }
    this.tabList.forEach(item => {
      if (item.title === "直播间" || item.title === "滚动播报") {
        item.icon =
          this.detail!.liveRoomDarkIcon ||
          require("../assets/image/直播间icon（未选中）@2x.png");
        item.activeIcon =
          this.detail!.liveRoomIcon ||
          require("../assets/image/直播间icon（选中）@2x.png");
      } else {
        item.icon =
          this.detail!.chatDarkIcon ||
          require("../assets/image/聊天室icon（未选中）@2x.png");
        item.activeIcon =
          this.detail!.chatIcon ||
          require("../assets/image/聊天室icon（选中）@2x.png");
      }
    });
    if (!this.detail!.isShowLiveRoom) {
      this.tabList.splice(
        this.tabList.findIndex(item => {
          return item.title === "直播间" || item.title === "滚动播报";
        }),
        1
      );
    }
    if (!this.detail!.isShowChat) {
      this.tabList.splice(
        this.tabList.findIndex(item => item.title === "聊天室"),
        1
      );
    }
  }

  /** 数据初始化 */
  init() {
    if (this.detail!.isShowLiveRoom) {
      this.getLiveRoom("mounted");
    }
    if (this.detail!.isShowChat) {
      this.getChatRoomList();
    }
    this.initTab();
    /** 开启弹幕 */
    this.showBarrage = this.detail!.isShowBulletScreen === 1;
    /** 弹幕名字 */
    this.showBarrageName = this.detail!.isShowBulletScreenName === 1;
    if (localStorage.getItem("barrageStatus") === "false") {
      this.showBarrage = false;
    }

    if (!this.isHighPerformance) {
      this.getLiveShareInfo();
      // 写死id不请求，减少性能
      if (this.$route.query.id != "96807269") {
        this.getGiftList();
      }
      this.getShareInfo();
      this.getLiveReply();
    }
  }

  /** 端外增加浏览量 */
  addViewCount() {
    // request
    //   .getCount(this.infoClassifyId, process.env.VUE_APP_COUNT_API)
    //   .then(() => {});
    request.getCount().then(() => {});
  }

  getImg(item: ITabItem, index: number) {
    if (index === this.active) {
      return item.activeIcon;
    } else {
      return item.icon;
    }
  }

  /** 获取点赞量、浏览量 */
  async getCountJson() {
    const result = await request.getCountJson();
    this.countJson = result;
  }

  /** 直播间、聊天室 定时轮询接口 */
  async taskList() {
    if (this.isstaticJson) {
      const result = await request.getStaticLiveRoom(
        this.$route.query.id as string
      );
      const current = this.tabList[this.active];
      this.liveRoomList = this.liveRoomList.concat(result.data);
      current.finished = true;
      return;
    }
    const time = this.detail?.pollTime || 8000;
    this.taskTimer = setInterval(() => {
      console.log("政务云接口开关", this.zwyIfcOn, new Date().format());
      if (this.zwyIfcOn) {
        console.log("轮询直播间、聊天室接口", new Date().format());
        this.getLiveReply(true);
        if (this.$route.query.id != "96807269") {
          this.getGiftTips();
        }
        if (this.detail!.isShowLiveRoom) {
          this.addLiveRoom();
        }
        if (this.detail!.isShowChat) {
          this.addChatRoom();
        }
      }
    }, time);
  }

  /** 定时更新 全局配置 */
  taskConfigList() {
    const time = 30000;
    this.taskConfigTimer = setInterval(() => {
      this.getConfigJson();
    }, time);
  }

  /** 定时更新点赞量、浏览量 */
  taskCountList() {
    const time = 10000;
    this.taskCountTimer = setInterval(() => {
      this.getCountJson();
    }, time);
  }

  /** 是否是第一次进入 */
  firstEntry = 0;

  /**
   * 获取全局配置
   * @param zwyIfcOn 如果直播的时候服务器压力报警，这个开关值改为 fale。
   */
  getConfigJson() {
    request
      .getConfigJsonById(this.infoClassifyId)
      .then(async result => {
        console.log("是否开启高并发", true, new Date().format());
        this.handleJson(true);
      })
      // 请求错误时使用
      .catch(async error => {
        this.handleJson(false);
      });
  }
  async handleJson(flag: boolean) {
    if (!this.firstEntry) {
      if (flag) {
        this.isHighPerformance = true;
        await this.getDetailByJson();
      } else {
        if (!this.firstEntry) {
          await this.getDetail();
        }
      }
      if (!this.firstEntry) {
        this.getAppConfig();
        recordCount({ news: this.detail, sourceType: "news" });
        recordTime({ news: this.detail, sourceType: "news" });
      }
      if (this.taskTimer) {
        clearInterval(this.taskTimer);
        this.taskList();
      } else {
        this.taskList();
      }
    }
    this.firstEntry = 1;
    // 后端商量说 固定这值为true
    this.zwyIfcOn = true;
  }
  /**
   * 高性能模式获取详情、
   * 分享参数、唤醒参数
   */
  async getDetailByJson() {
    const result = await request.getDetailByJson();
    this.detail = result.liveRoomDetailDto;
    document.title = this.detail.title;
    this.$store.commit("SET_STATE", {
      detail: result.liveRoomDetailDto,
      appId: result.liveRoomDetailDto.appId || "1",
      liveShare: result.liveShare
    });
    if (!this.firstEntry) {
      this.init();
    }
    this.getShareInfo(result.shareInfoData);
    this.getLiveShareInfo(result.liveShare);
  }
  /** 获取详情 */
  @needToken(false)
  async getDetail() {
    const result = await request.detail(this.infoClassifyId);
    if (result.code === 0) {
      this.detail = result.data;
      document.title = this.detail.title;
      this.$store.commit("SET_STATE", {
        detail: result.data,
        appId: result.data.appId || "1"
      });
      this.init();
    } else {
      if (result.message == "该新闻已下线") {
        this.$router.push("/404");
      }
    }
  }

  /** 注册分享信息 */
  async getLiveShareInfo(data?: ILiveShare) {
    let detail: ILiveShare | null = null;
    if (native.isOpenInApp()) {
      if (data) {
        detail = data;
      } else {
        const result = await request.liveShare(this.infoClassifyId);
        detail = result.data;
      }
      native.setShareConfig({
        id: this.infoClassifyId + "",
        title: detail.shareTitle,
        content: detail.synopsis,
        icon: detail.shareImgUrl,
        url: detail.shareUrl,
        sourceType: detail.sourceType + ""
      });
    }
  }
  showcommentfun(data: any) {
    this.showcomment = true;
    this.commentSavedata = data;
    console.log(data);
  }
  async commentSave() {
    if (this.message == "") return;
    const result = await request.commentSave({
      isAnonymous: this.checked,
      content: this.message,
      columnsType: 0,
      sourceType: this.commentSavedata!.sourceType,
      sourceId: this.commentSavedata!.sourceId,
      passiveReplyName: this.commentSavedata!.passiveReplyName,
      passiveReplyId: this.commentSavedata!.passiveReplyId
    });
    if (result.code == 0 || result.code == 1) {
      this.showcomment = false;
      setTimeout(() => {
        Toast(result.message);
        this.message = "";
        this.checked = false;
      }, 500);
    }
  }
  /** 底部分享按钮 */
  footerShareClick() {
    native.shareApp();
  }
  @needToken(true)
  /** 底部按钮 */
  footerClick(text: string, value?: boolean) {
    new Map([
      [
        "gift",
        () => {
          this.showGift = true;
        }
      ],
      [
        "zan",
        async () => {
          if (this.isHighPerformance) {
            if (!this.zanStatus) {
              if (!isNaN(Number(this.countJson?.praiseCount))) {
                this.countJson!.praiseCount =
                  Number(this.countJson?.praiseCount) + 1 + "";
              }
            }
            this.zanStatus = true;
          }
          const result = await request.doPraise(
            "",
            this.detail!.title,
            this.detail!.informationId,
            0,
            1
          );
          if (!result.code) {
            if (!this.isHighPerformance) {
              /** showPraiseCount 在没上万的时候和praiseCount数值一致 */
              if (
                this.detail!.showPraiseCount ===
                this.detail!.praiseCount + ""
              ) {
                this.detail!.showPraiseCount = String(
                  this.detail!.praiseCount + 1
                );
                this.detail!.praiseCount += 1;
              }
              this.detail!.isPraise = true;
            }
          }
        }
      ],
      [
        "barrage",
        () => {
          this.showBarrage = value!;
        }
      ]
    ]).get(text)!();
  }

  /** 获取礼物列表 */
  async getGiftList() {
    const result = await request.giftList();
    if (result.code === 0) {
      this.giftList = result.data.pageResults;
    }
  }

  /** 获取顶部唤醒APP信息 */
  async getShareInfo(data?: IShareInfo) {
    if (data) {
      this.shareInfo = data;
      this.$store.commit("SET_STATE", {
        downloadUrl: data.downloadUrl
      });
    } else {
      const result = await request.getShareInfo();
      if (result.code === 0) {
        this.shareInfo = result.data;
        this.$store.commit("SET_STATE", {
          downloadUrl: result.data.downloadUrl
        });
      }
    }
  }
  /** 获取直播间列表 */
  @toastWithDelay({
    message: "加载中...",
    forbidClick: true,
    overlay: true,
    condition: (tag: "mounted" | "sort" | "load") => tag === "mounted"
  })
  @needToken(false)
  async getLiveRoom(tag?: "mounted" | "sort" | "load") {
    if (this.isstaticJson) {
      await request.getStaticLiveRoom(this.infoClassifyId);
      return;
    }
    const lastItem = this.liveRoomList.lastChild || { id: "" };
    const current = this.tabList[this.active];
    const result = await request.getLiveRoom(
      this.infoClassifyId,
      lastItem.compereId || undefined,
      lastItem.id || undefined,
      lastItem.sortNo || undefined,
      lastItem.createTime || undefined,
      this.hostIds,
      this.liveRoomSort
    );
    if (result.code == 0 && this.liveRoomSort == "") {
      if (result.message) {
        this.liveRoomSort = result.message;
      } else {
        this.liveRoomSort = "DESC";
      }
    }
    if (!result.data || result.data.length === 0) {
      current.finished = true;
    } else {
      this.liveRoomList = this.liveRoomList.concat(result.data);
    }
    if (tag === "sort" || tag === "mounted") {
      this.tabList.find(item => {
        return item.title === "直播间" || item.title === "滚动播报";
      })!.finished = false;
    }
    if (tag === "load" || tag === "mounted") {
      this.tabList.find(item => {
        return item.title === "直播间" || item.title === "滚动播报";
      })!.onLoad = () => {
        this.getLiveRoom("load");
      };
    }
    current.loading = false;
  }
  newsort(i: number) {
    this.chatRoomSortindex = i;
    this.showChatRoomSort = false;
    this.chatRoomList = [];
    this.getChatRoomList();
  }
  /** 获取聊天室列表 */
  @needToken(false)
  async getChatRoomList() {
    const lastItem = this.chatRoomList.lastChild || {};
    const current = this.tabList[this.active];
    const result = await request.getChatRoom(
      this.infoClassifyId,
      lastItem.createTime,
      lastItem.id,
      this.chatRoomSort[this.chatRoomSortindex].value
    );
    if (!result.data || result.data.length === 0) {
      current.finished = true;
    } else {
      this.chatRoomList = this.chatRoomList.concat(result.data);
    }
    current.loading = false;
  }

  @needToken(false)
  async addLiveRoom() {
    if (this.isstaticJson) {
      return;
    }
    if (this.liveRoomSort === "ASC") {
      return;
    }
    const firstItem = this.liveRoomList[0] || { id: "" };
    const result = await request.getLiveRoom(
      this.infoClassifyId,
      firstItem.compereId,
      firstItem.id,
      firstItem.sortNo,
      firstItem.createTime,
      this.hostIds,
      "ASC"
    );
    if (result.data && result.data.length > 0) {
      result.data.forEach(item => {
        this.liveRoomList.unshift(item);
      });
    }
  }

  @needToken(false)
  async addChatRoom() {
    const result = await request.getChatRoom(
      this.infoClassifyId,
      "",
      undefined,
      this.chatRoomSort[this.chatRoomSortindex].value
    );
    if (result.data && result.data.length > 0) {
      // 将已点赞的数据同步到新加的数据中
      result.data.forEach(item => {
        const i = this.chatRoomList.find(i => i.id === item.id);
        if (i) {
          item.isPraise = i.isPraise;
        }
      });
      const { length } = result.data;
      // 处理最新页不满10条的特殊情况
      if (length < 10) {
        this.chatRoomList = result.data;
      } else {
        this.chatRoomList.splice(0, length);
        this.chatRoomList = result.data.concat(this.chatRoomList);
      }
    }
  }

  doPraise(id: number, type: 1 | 2) {
    if (type === 1) {
      const item = this.liveRoomList.find(item => item.id === id)!;
      item.isPraise = true;
      item.praiseCount += 1;
    } else {
      const item = this.chatRoomList.find(item => item.id === id)!;
      item.isPraise = true;
      item.praise += 1;
    }
  }

  /** 设置直播间评论升序降序排列 */
  setSort() {
    // this.tabList.find(item => item.title === "直播间")!.finished = false;
    this.liveRoomSort = this.liveRoomSort === "DESC" ? "ASC" : "DESC";
    this.liveRoomList = [];
    this.getLiveRoom("sort");
  }

  /** 获取弹幕列表 */
  async getLiveReply(isAdd = false) {
    const lastItem = this.barrageList.lastChild || {};
    const result = await request.liveReply(this.infoClassifyId, lastItem.id);
    if (result.code === 0) {
      if (isAdd) {
        this.barrageList = this.barrageList.concat(result.data);
      } else {
        this.barrageList = result.data;
      }
    }
  }

  /** 跳转筛选主持人页 */
  screen() {
    this.liveRoomList = [];
    this.$router.push(`/host-filter?id=${this.$store.state.infoClassifyId}`);
  }

  /** 获取礼物 */
  async getGiftTips() {
    const result = await request.giftTips(
      this.detail!.informationId,
      this.detail?.pollTime || 8000
    );
    if (result.code === 0) {
      this.giftTips = this.giftTips.concat(result.data);
    }
  }

  removeList(length: number) {
    if (this.barrageList.length > 50) {
      this.barrageList.splice(0, this.barrageList.length - length);
    }
  }

  removeGiftTips(length: number) {
    this.giftTips.splice(0, this.giftTips.length - length);
  }

  deactivated() {
    clearInterval(this.taskTimer);
    clearInterval(this.taskCountTimer);
    clearInterval(this.taskConfigTimer);
  }
}
